import { FormikProps, getIn } from 'formik';
import * as _ from 'lodash';
import React from 'react';

import { DeleteIconButton } from 'packages/common-frontend/components/IconButton';

type DeletePropertyButtonProps = {
  formProps: FormikProps<any>;
  basePropertyKey: string;
  propertyKey: string;
};
export const DeletePropertyButton = ({
  formProps,
  basePropertyKey,
  propertyKey,
}: DeletePropertyButtonProps) => {
  const propertySection = getIn(formProps.values, basePropertyKey);
  const updatedPropertySection = _.omit(propertySection, propertyKey);
  return (
    <DeleteIconButton
      ariaLabel="delete"
      label="Delete"
      onClick={(event) => {
        if (event) {
          event.stopPropagation();
        }
        return formProps.setFieldValue(basePropertyKey, updatedPropertySection);
      }}
    />
  );
};
